const association = {
  // HeroSection
  'association.hero.homeLink': 'Home',
  'association.hero.aboutLink': 'About the Academy',
  'association.hero.currentPage': 'About the Association',
  'association.hero.title': 'About the Association',
  'association.hero.titleEn': 'THE ASSOCIATION',
  'association.hero.lead': 'The Japan Butler Academy is operated by The All Japan Butler Association, an incorporated association. The Association was founded in 1890 (Meiji 23), and was established as an incorporated association on February 19, 2025.',
  'association.hero.imgAlt': 'An elegant and formal interior',
  'association.role.imgAlt': 'An image of the official certificate and pin badge issued by the Association',

  // AssociationRole
  'association.role.label': 'OUR ROLE',
  'association.role.title': 'What is The All Japan Butler Association?',
  'association.role.subtitleEn': 'What is the Japan Butler Association?',
  'association.role.sub1': 'Our Parent Body: The All Japan Butler Association',
  'association.role.sub2': 'Training, Certification, and Career Support',
  'association.role.sub3': 'Corporate Training vs. Certified Credential',
  'association.role.para1': 'The parent body of The Japan Butler Academy is The All Japan Butler Association. Through butler training and certification, as well as corporate training programmes, the Association is committed to establishing butler culture in Japan.',
  'association.role.para2': 'The Association\'s work extends well beyond training butlers. By consistently delivering three functions — issuing credentials that guarantee the quality of the professionals we develop, providing corporate training that brings butler hospitality skills into business environments, and building career support systems for graduates — we aim to elevate the social standing of the butler profession.',
  'association.role.para3': 'Please note that the corporate training we offer is business etiquette education grounded in butler hospitality skills. \n\nIt does not confer a butler credential on corporate participants, which is distinct from the Association-certified credential awarded through our core programmes. \n\nFurther details of future initiatives will be published in due course as plans are confirmed.',

  // AssociationServices
  'association.services.label': 'WHAT WE OFFER',
  'association.services.title': 'What the Association Provides',
  'association.services.subtitleEn': 'Services of the Association',
  'association.services.lead': 'The Association\'s role falls into four broad areas: the core programme that trains butlers, the credentials that verify their learning, corporate training that supports workplaces, and developing career pathways for graduates.',
  'association.services.viewLink': 'Learn more',
  'association.services.1.title': 'Butler Training (Core Programme — 3 Courses)',
  'association.services.1.desc': 'Three progressive levels — Essential, Advanced, and Master — provide structured instruction from foundational skills through to management and crisis response. Weekend classes, maximum 6 students.',
  'association.services.2.title': 'Association Certification',
  'association.services.2.desc': 'Graduates who complete the designated programme and pass the practical examination receive an official butler credential from The All Japan Butler Association — confirmation that they have met the Association\'s standards.',
  'association.services.3.title': 'Corporate Training (Hospitality & Business Etiquette)',
  'association.services.3.desc': 'We deliver corporate training grounded in butler hospitality skills, either on-site at your organisation or at our campus, with programmes tailored to your specific workplace needs.',
  'association.services.4.title': 'Career Support for Graduates (Coming Soon)',
  'association.services.4.desc': 'We are developing a system to share butler-related employment information with graduates as one career pathway available to them after completing the programme.',

  // AssociationTable
  'association.table.label': 'ORGANIZATION',
  'association.table.title': 'Association Overview',
  'association.table.subtitleEn': 'Association Overview',
  'association.table.label1': 'Name',
  'association.table.value1': 'The All Japan Butler Association (Incorporated Association)',
  'association.table.label2': 'Address',
  'association.table.value2': '2-7-4 Aomi, Koto-ku, Tokyo 135-0064 (Odaiba)',
  'association.table.label3': 'Telephone',
  'association.table.value3': '+81-3-6824-4086 (Reception: Weekdays 10:00–17:00)',
  'association.table.label4': 'Email',
  'association.table.value4': 'info@butler-academy.jp',
  'association.table.label5': 'Business Activities',
  'association.table.value5': 'Butler training, credential certification, corporate training, graduate career support (forthcoming)',
  'association.table.label6': 'Representative',
  'association.table.value6': 'Yuichi Ishii (Butler Bell), Representative Director (Third Todori, head of the Association)',
  'association.table.label7': 'Founded',
  'association.table.value7': '1890 (Meiji 23)',
  'association.table.label8': 'Incorporated',
  'association.table.value8': 'February 19, 2025 (as The All Japan Butler Association, an incorporated association)',

  // ContactGuide
  'association.contact.label': 'CONTACT',
  'association.contact.title': 'Contact Us',
  'association.contact.subtitleEn': 'Get in Touch',
  'association.contact.body': 'For general enquiries or media requests, please use our contact form. Brochure requests are sent free of charge.',
  'association.contact.ctaContact': 'Contact Us',
  'association.contact.ctaBrochure': 'Request a Brochure (Free)',

  // FAQ
  'association.faq.label': 'FAQ',
  'association.faq.title': 'Frequently Asked Questions',
  'association.faq.subtitleEn': 'Frequently Asked Questions',
  'association.faq.footer': 'For further enquiries, please use our contact form.',
  'association.faq.q1': 'What does the Association do?',
  'association.faq.a1': 'We train butlers (by operating this Academy), certify Association credentials, deliver hospitality and business etiquette training for corporate clients, and provide career support for graduates (forthcoming).',
  'association.faq.q2': 'Is the credential a national qualification?',
  'association.faq.a2': 'No. It is a private credential independently certified by the Association, awarded to those who pass the practical examination at the end of the programme.',
  'association.faq.q3': 'Can we request corporate training?',
  'association.faq.a3': 'Yes. We offer business etiquette training grounded in butler hospitality skills, available in both on-site and at-campus formats. Please see our Corporate Training page for details.',

  // CTA
  'association.cta.label': 'TAKE THE NEXT STEP',
  'association.cta.title': 'Feel free to reach out',
  'association.cta.body': 'Whether you have questions about our courses, certification, or corporate training, please do not hesitate to get in touch.',
  'association.cta.note': '* Online consultations are also available.',
  'association.cta.courses': 'Explore Courses',
  'association.cta.corporate': 'Corporate Training',

  // RelatedPages
  'association.related.title': 'Related Pages',
  'association.related.subtitleEn': 'Explore Further',
  'association.related.viewLink': 'Learn more',
  'association.related.backLink': 'Back to About the Academy',
  'association.related.link0.title': 'About the Academy',
  'association.related.link0.desc': 'A full overview of the Academy',
  'association.related.link1.title': 'Certificate & Certification',
  'association.related.link1.desc': 'The Association credential earned upon completion',
  'association.related.link2.title': 'Corporate Training',
  'association.related.link2.desc': 'Hospitality and business etiquette training for organisations',
  'association.related.link3.title': 'Contact Us',
  'association.related.link3.desc': 'For enquiries and consultations',
  'association.related.link4.title': "President's Message",
  'association.related.link4.desc': 'A message from the president, Butler Bell',
  'association.related.link5.title': 'The Japan Butler Association: Business Overview',
  'association.related.link5.desc': 'A detailed introduction to the services the Association provides',

  // Last updated
  'association.lastUpdated': 'Last updated: 8 July 2026',
};

export default association;
